<template>
  <div class="metrics-grid">
    <!-- Charge Availability -->
    <v-card :loading="loading">
      <div class="metric-card">
        <div class="metric-label">
          CHARGER AVAILABILITY
        </div>
        <div class="metric-value primary-value">
          {{ items?.connector_availability_avg_percent || 0 }}%
        </div>
        <!-- <div class="target-badge">
        <span class="target-label">Target</span>
        <span class="target-value">{{ networkTarget }}%</span>
      </div> -->
      </div>
    </v-card>
    <!-- Network Availability -->
    <v-card :loading="loading">
      <div class="metric-card">
        <div class="metric-label">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
              >
                <span>NETWORK AVAILABILITY</span>
                <v-icon
                  small
                  class="info-icon ml-2"
                >
                  mdi-information-outline
                </v-icon>
              </div>
            </template>
            <span>
              How much of the time your charging network was working and ready
              to use.
            </span>
          </v-tooltip>
        </div>
        <div class="metric-value primary-value">
          {{ items?.network_availability_percent || 0 }}%
        </div>
        <!-- <div class="target-badge">
        <span class="target-label">Target</span>
        <span class="target-value">{{ networkTarget }}%</span>
      </div> -->
      </div>
    </v-card>

    <!-- Total Active Connectors -->
    <v-card :loading="loading">
      <div class="metric-card">
        <div class="metric-label">
          TOTAL ACTIVE CONNECTORS
        </div>
        <div class="metric-value primary-value connector-value">
          {{ items?.connector_count || 0 }}
        </div>
        <!-- <div class="connector-meta">
          <div class="meta-row">
            <span class="meta-dot global" />
            <span class="meta-text">Global Fleet</span>
            <span class="meta-count">{{ globalFleet }}</span>
          </div>
          <div class="meta-row">
            <span class="meta-dot regions" />
            <span class="meta-text">Regions</span>
            <span class="meta-count">{{ regions }}</span>
          </div>
        </div> -->
      </div>
    </v-card>

    <!-- SLA Status -->
    <v-card :loading="loading">
      <div class="metric-card">
        <div class="metric-label">
          SLA Target
        </div>
        <div class="metric-value primary-value connector-value">
          {{ items?.sla?.target_percentage || 0 }}%
        </div>
        <div class="audit-label">
          SLA Band: {{ items?.sla?.band }}
        </div>
      </div>
    </v-card>

    <!-- Quarterly Penalty/Bonus -->
    <v-card :loading="loading">
      <div class="metric-card">
        <div class="metric-label">
          QUARTERLY PENALTY/BONUS
        </div>
        <div
          class="metric-value primary-value quarterly-value"
          :class="items?.quarter >= 0 ? 'positive' : 'negative'"
        >
          {{ items?.quarter?.toFixed(2) || 0 }}
          <span>PKR</span>
        </div>
        <div
          class="change-row"
          :class="items?.quarter >= 0 ? 'positive' : 'negative'"
        >
          <v-icon small>
            {{ items?.quarter >= 0 ? "mdi-trending-up" : "mdi-trending-down" }}
          </v-icon>
          <span>
            {{ items?.quarter >= 0 ? "+" : "" }}{{ items?.quarter }}% from Prev.
            Quarter
          </span>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "NetworkMetricsBanner",

  props: {
    loading: Boolean,
    items: {
      type: Object,
      default: () => ({}),
    },

    quarterlyAmount: {
      type: Number,
      default: 0,
    },
    quarterlyChange: {
      type: Number,
      default: 4.2,
    },
  },
};
</script>

<style scoped>
.metrics-banner {
  background: #f0f2f5;
  border: 1px solid #e8ecf0;
  border-radius: 14px;
  padding: 1rem 0;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.metrics-grid {
  display: flex;
  align-items: stretch;
  gap: 1rem;
}

.v-card {
  flex: 1;
}

/* ── Cards ── */
.metric-card {
  flex: 1;
  padding: 25px 25px 15px 25px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  background: #ffffff;
  border-radius: 10px;
}

/* ── Labels ── */
.metric-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.12em;
  color: #8a94a6;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 4px;
}

.info-icon {
  color: #b0bac8 !important;
  font-size: 14px !important;
}

/* ── Primary Values ── */
.primary-value {
  /* font-family: "DM Mono", monospace; */
  font-size: 36px;
  font-weight: 500;
  color: #1a202c;
  line-height: 1;
  margin-top: 4px;
  display: flex;
  align-items: center;
}

.primary-value span {
  font-weight: 600;
  font-size: 16px;
}

.connector-value {
  font-size: 36px;
}

/* ── Target Badge ── */
.target-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #1a202c;
  color: #fff;
  border-radius: 5px;
  padding: 3px 8px;
  width: fit-content;
}

.target-label {
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #94a3b8;
  text-transform: uppercase;
}

.target-value {
  /* font-family: "DM Mono", monospace; */
  font-size: 11px;
  font-weight: 500;
  color: #ffffff;
}

/* ── Connector Meta ── */
.connector-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 2px;
}

.meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.meta-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.meta-dot.global {
  background: #6366f1;
}
.meta-dot.regions {
  background: #94a3b8;
}

.meta-text {
  font-size: 11px;
  color: #8a94a6;
  font-weight: 400;
}

.meta-count {
  /* font-family: "DM Mono", monospace; */
  font-size: 11px;
  color: #4a5568;
  font-weight: 500;
}

/* ── SLA Badge ── */
.sla-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  width: fit-content;
  margin-top: 4px;
}

.sla-badge.compliant {
  background: #d1fae5;
  color: #065f46;
}

.sla-badge.at.risk {
  background: #fef3c7;
  color: #92400e;
}

.sla-badge.breached {
  background: #fee2e2;
  color: #991b1b;
}

.sla-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}

.audit-label {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 400;
}

/* ── Quarterly ── */
.quarterly-value.positive {
  color: #1a202c;
}
.quarterly-value.negative {
  color: #dc2626;
}

.change-row {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
}

.change-row.positive {
  color: #059669;
}

.change-row.negative {
  color: #dc2626;
}

.change-row .v-icon {
  color: inherit !important;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .metrics-grid {
    flex-direction: column;
  }

  .divider {
    width: 100%;
    height: 1px;
  }

  .primary-value {
    font-size: 28px;
  }
}
</style>
